import { Link } from "react-router-dom";

export default function FooterBrand() {
  return (
    <div className="site-footer__brand-top">
      <Link to="/" className="site-footer__brand-link">
        <div className="site-footer__brand-icon">
          <img
            src="/assets/images/logo/Logo.png"
            alt="Logo Dionara Krause"
            className="site-footer__logo"
          />
        </div>

        <div className="site-footer__brand-text">
          <h3>Dionara Krause</h3>
          <span>ESTÉTICA E NUTRIÇÃO</span>
        </div>
      </Link>
    </div>
  );
}